module.exports = __webpack_public_path__ + "static/lilli-0a1079b9550cabd7756063ad5ee76421.jpg";